(() => {
  const root = document.querySelector("[data-virelle-wow]");
  if (!root) return;

  const variantId = Number(root.dataset.variantId || 0);
  const unitPrice = Number(root.dataset.price || 299);
  const boostVariantId = Number(root.dataset.boostVariantId || 0);
  const state = { qty: 1, cartQty: 0, boostQty: 0, cartTotal: 0, cartItemCount: 0, lineTotal: 0, lang: "he" };
  let boostShown = false;
  try { boostShown = sessionStorage.getItem("virelle-boost-shown") === "1"; } catch (_) {}

  const qs = (sel, el = root) => el.querySelector(sel);
  const qsa = (sel, el = root) => [...el.querySelectorAll(sel)];
  const money = (n) =>
    state.lang === "en"
      ? `NIS ${n.toLocaleString("en-US")}`
      : `${n.toLocaleString("he-IL")} ₪`;
  const toast = qs("[data-toast]");
  const cartDrawer = qs("[data-cart-drawer]");
  const stickyBuy = qs("[data-sticky-buy]");
  const qtyInput = qs("[data-qty]");
  const progress = document.querySelector(".virelle-wow .scroll-progress span");
  const msg = {
    he: {
      missing: "חסר מזהה מוצר",
      added: "נוסף לעגלה",
      addError: "שגיאה בהוספה לעגלה",
      updateError: "שגיאה בעדכון העגלה",
    },
    en: {
      missing: "Missing product id",
      added: "Added to cart",
      addError: "Could not add to cart",
      updateError: "Could not update cart",
    },
  };

  function applyLang(lang) {
    state.lang = lang === "en" ? "en" : "he";
    root.dataset.lang = state.lang;
    root.setAttribute("dir", state.lang === "en" ? "ltr" : "rtl");
    root.setAttribute("lang", state.lang);
    try {
      localStorage.setItem("virelle-lang", state.lang);
    } catch (_) {}

    const boostPopup = qs("[data-boost-popup]");
  let boostPendingCheckout = false;
  let boostReturnFocus = null;
  function showBoost(goCheckout) {
    if (!boostPopup || state.boostQty || !state.cartQty) return;
    boostPendingCheckout = goCheckout;
    boostShown = true;
    try { sessionStorage.setItem("virelle-boost-shown", "1"); } catch (_) {}
    boostReturnFocus = document.activeElement;
    boostPopup.hidden = false;
    qs("[data-boost-branch]")?.focus();
  }
  function hideBoost(continueCheckout = false) {
    if (!boostPopup) return;
    boostPopup.hidden = true;
    const pending = boostPendingCheckout;
    boostPendingCheckout = false;
    boostReturnFocus?.focus?.();
    if (continueCheckout && pending) window.location.href = "/checkout";
  }
  qsa("[data-close-boost]").forEach((el) => el.addEventListener("click", () => hideBoost(false)));
  qs("[data-skip-boost]")?.addEventListener("click", () => hideBoost(true));
  boostPopup?.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hideBoost(false);
    if (e.key !== "Tab") return;
    const focusables = [...boostPopup.querySelectorAll("button,select")].filter((el) => !el.disabled);
    const first = focusables[0], last = focusables.at(-1);
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  qs("[data-add-boost]")?.addEventListener("click", async (e) => {
    const branch = qs("[data-boost-branch]")?.value || "";
    const error = qs("[data-boost-error]");
    if (!branch) { if (error) {error.hidden = false; error.textContent = "בחרי סניף כדי להוסיף את הטיפול.";} return; }
    e.currentTarget.disabled = true;
    if (error) error.hidden = true;
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST", headers: {"Content-Type":"application/json", Accept:"application/json"},
        body: JSON.stringify({items:[{id:boostVariantId,quantity:1,properties:{"סניף מועדף":branch}}]})
      });
      if (!res.ok) throw new Error("boost add failed");
      await syncFromShopify();
      hideBoost(true);
      showToast("טיפול הבוסט נוסף לעגלה");
    } catch (_) {
      if (error) {error.hidden = false; error.textContent = "לא הצלחנו להוסיף את הטיפול. נסי שוב.";}
    } finally { e.currentTarget.disabled = false; }
  });
  qs("[data-remove-boost]")?.addEventListener("click", async () => {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      const line = cart.items.find((i) => i.variant_id === boostVariantId);
      if (!line) return;
      const update = await fetch("/cart/change.js", {method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:line.key,quantity:0})});
      if (!update.ok) throw new Error("remove failed");
      await syncFromShopify();
    } catch (_) { showToast("updateError"); }
  });

  qsa("[data-set-lang]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.setLang === state.lang);
    });

    const heTrack = qs("[data-marquee-he]");
    const enTrack = qs("[data-marquee-en]");
    if (heTrack && enTrack) {
      heTrack.hidden = state.lang !== "he";
      enTrack.hidden = state.lang !== "en";
    }

    qsa("[data-slogan]").forEach((el) => {
      const next = el.getAttribute(`data-slogan-${state.lang}`);
      if (next) el.textContent = next;
    });

    qsa("[data-he][data-en]").forEach((el) => {
      el.textContent = el.getAttribute(`data-${state.lang}`) || el.textContent;
    });

    updateCartUI();
    tick();
  }

  function showToast(keyOrText) {
    if (!toast) return;
    toast.textContent = msg[state.lang][keyOrText] || keyOrText;
    toast.classList.add("is-on");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove("is-on"), 2200);
  }

  function setQty(next) {
    state.qty = Math.min(10, Math.max(1, next));
    if (qtyInput) qtyInput.value = String(state.qty);
  }

  function updateCartUI() {
    const empty = qs("[data-cart-empty]");
    const filled = qs("[data-cart-filled]");
    const lineTotal = state.lineTotal / 100;
    qs("[data-virelle-line]")?.toggleAttribute("hidden", state.cartQty === 0);
    const total = state.cartTotal / 100;
    qs("[data-boost-line]")?.toggleAttribute("hidden", state.boostQty === 0);
    document.querySelectorAll("[data-virelle-cart-count]").forEach((count) => {
      count.textContent = String(state.cartItemCount);
      count.classList.toggle("is-on", state.cartItemCount > 0);
    });
    if (!empty || !filled) return;
    if (state.cartItemCount <= 0) {
      empty.hidden = false;
      filled.hidden = true;
      return;
    }
    empty.hidden = true;
    filled.hidden = false;
    const qtyEl = qs("[data-cart-qty]");
    if (qtyEl) qtyEl.textContent = String(state.cartQty);
    qs("[data-cart-line-total]")?.replaceChildren(document.createTextNode(money(lineTotal)));
    qsa("[data-cart-sub], [data-cart-total]").forEach((el) => {
      el.textContent = money(total);
    });
  }

  function openCart() {
    cartDrawer?.classList.add("is-open");
    cartDrawer?.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    if (boostVariantId && state.cartQty && !state.boostQty && !boostShown) showBoost(false);
  }

  function closeCart() {
    cartDrawer?.classList.remove("is-open");
    cartDrawer?.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  async function syncFromShopify() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      const line = (cart.items || []).find((i) => i.variant_id === variantId || i.id === variantId);
      state.cartQty = line ? line.quantity : 0;
      state.lineTotal = line ? line.final_line_price : 0;
      state.boostQty = (cart.items || []).filter((i) => i.variant_id === boostVariantId).reduce((n, i) => n + i.quantity, 0);
      state.cartTotal = cart.total_price || 0;
      state.cartItemCount = cart.item_count || 0;
      updateCartUI();
    } catch (_) {}
  }

  async function addToCart(qty = state.qty, goCheckout = false) {
    if (!variantId) {
      showToast("missing");
      return;
    }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
      });
      if (!res.ok) throw new Error("add failed");
      await syncFromShopify();
      showToast("added");
      openCart();
      if (goCheckout) {
        if (boostVariantId && !state.boostQty && !boostShown) showBoost(true);
        else window.location.href = "/checkout";
      }
    } catch (_) {
      showToast("addError");
    }
  }

  async function updateShopifyQty(qty) {
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: { [variantId]: qty } }),
      });
      if (!res.ok) throw new Error("update failed");
      await syncFromShopify();
    } catch (_) {
      showToast("updateError");
    }
  }

  const boostPopup = qs("[data-boost-popup]");
  let boostPendingCheckout = false;
  let boostReturnFocus = null;
  function showBoost(goCheckout) {
    if (!boostPopup || state.boostQty || !state.cartQty) return;
    boostPendingCheckout = goCheckout;
    boostShown = true;
    try { sessionStorage.setItem("virelle-boost-shown", "1"); } catch (_) {}
    boostReturnFocus = document.activeElement;
    boostPopup.hidden = false;
    qs("[data-boost-branch]")?.focus();
  }
  function hideBoost(continueCheckout = false) {
    if (!boostPopup) return;
    boostPopup.hidden = true;
    const pending = boostPendingCheckout;
    boostPendingCheckout = false;
    boostReturnFocus?.focus?.();
    if (continueCheckout && pending) window.location.href = "/checkout";
  }
  qsa("[data-close-boost]").forEach((el) => el.addEventListener("click", () => hideBoost(false)));
  qs("[data-skip-boost]")?.addEventListener("click", () => hideBoost(true));
  boostPopup?.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hideBoost(false);
    if (e.key !== "Tab") return;
    const focusables = [...boostPopup.querySelectorAll("button,select")].filter((el) => !el.disabled);
    const first = focusables[0], last = focusables.at(-1);
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  qs("[data-add-boost]")?.addEventListener("click", async (e) => {
    const branch = qs("[data-boost-branch]")?.value || "";
    const error = qs("[data-boost-error]");
    if (!branch) { if (error) {error.hidden = false; error.textContent = "בחרי סניף כדי להוסיף את הטיפול.";} return; }
    e.currentTarget.disabled = true;
    if (error) error.hidden = true;
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST", headers: {"Content-Type":"application/json", Accept:"application/json"},
        body: JSON.stringify({items:[{id:boostVariantId,quantity:1,properties:{"סניף מועדף":branch}}]})
      });
      if (!res.ok) throw new Error("boost add failed");
      await syncFromShopify();
      hideBoost(true);
      showToast("טיפול הבוסט נוסף לעגלה");
    } catch (_) {
      if (error) {error.hidden = false; error.textContent = "לא הצלחנו להוסיף את הטיפול. נסי שוב.";}
    } finally { e.currentTarget.disabled = false; }
  });
  qs("[data-remove-boost]")?.addEventListener("click", async () => {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      const line = cart.items.find((i) => i.variant_id === boostVariantId);
      if (!line) return;
      const update = await fetch("/cart/change.js", {method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:line.key,quantity:0})});
      if (!update.ok) throw new Error("remove failed");
      await syncFromShopify();
    } catch (_) { showToast("updateError"); }
  });

  qsa("[data-set-lang]").forEach((btn) => {
    btn.addEventListener("click", () => applyLang(btn.dataset.setLang));
  });

  qsa("[data-add-to-cart]").forEach((btn) => {
    btn.addEventListener("click", () => addToCart(state.qty, false));
  });
  qsa("[data-buy-now]").forEach((btn) => {
    btn.addEventListener("click", () => addToCart(state.qty, true));
  });
  qs("[data-qty-minus]")?.addEventListener("click", () => setQty(state.qty - 1));
  qs("[data-qty-plus]")?.addEventListener("click", () => setQty(state.qty + 1));
  qs("[data-cart-minus]")?.addEventListener("click", () => {
    const next = Math.max(0, state.cartQty - 1);
    updateShopifyQty(next);
  });
  qs("[data-cart-plus]")?.addEventListener("click", () => {
    const next = Math.min(10, state.cartQty + 1);
    updateShopifyQty(next);
  });
  const openCartBtns = [
    ...qsa("[data-open-cart]"),
    ...document.querySelectorAll("[data-open-cart]"),
  ];
  [...new Set(openCartBtns)].forEach((el) => el.addEventListener("click", openCart));
  qsa("[data-close-cart]").forEach((el) => el.addEventListener("click", closeCart));
  qs("[data-checkout]")?.addEventListener("click", (e) => {
    e.preventDefault();
    if (state.cartItemCount > 0) {
      if (boostVariantId && state.cartQty && !state.boostQty && !boostShown) showBoost(true);
      else window.location.href = "/checkout";
    } else addToCart(state.qty, true);
  });
  qs("[data-scroll-top]")?.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  qsa("[data-scroll-buy]").forEach((el) => {
    el.addEventListener("click", () => qs("#buy")?.scrollIntoView({ behavior: "smooth" }));
  });

  const hero = qs("[data-hero]");
  const heroVideo = qs("[data-hero-video]");
  if (heroVideo) {
    const markReady = () => {
      if (heroVideo.videoWidth > 0) {
        heroVideo.classList.add("is-ready");
        hero?.classList.add("has-video");
      }
    };
    heroVideo.addEventListener("loadeddata", markReady);
    heroVideo.play?.().then(markReady).catch(() => {});
  }

  const frames = qsa(".film-frame");
  let frameIndex = 0;
  setInterval(() => {
    if (!frames.length || hero?.classList.contains("has-video")) return;
    frames.forEach((f, i) => f.classList.toggle("is-active", i === frameIndex));
    frameIndex = (frameIndex + 1) % frames.length;
  }, 4200);

  const slogans = qsa("[data-slogan]");
  let sloganIndex = 0;
  if (slogans.length) {
    const show = () => {
      slogans.forEach((el, i) => el.classList.toggle("is-on", i === sloganIndex));
      sloganIndex = (sloganIndex + 1) % slogans.length;
    };
    show();
    setInterval(show, 3200);
  }

  const revealIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        revealIo.unobserve(entry.target);
      });
    },
    { threshold: 0.14, rootMargin: "0px 0px -8% 0px" }
  );
  qsa("[data-reveal]").forEach((el) => revealIo.observe(el));

  function parseOfferEnd(raw) {
    if (!raw) return NaN;
    let value = String(raw).trim().replace(" ", "T");
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(value)) {
      value += "+03:00";
    }
    const ms = Date.parse(value);
    return Number.isNaN(ms) ? NaN : ms;
  }

  const endAt = parseOfferEnd(root.dataset.offerEnd);
  const tick = () => {
    const pad = (n) => String(n).padStart(2, "0");
    const label = qs("[data-cd-label]");
    const daysWrap = qs("[data-cd-days-wrap]");
    const dEl = qs("[data-cd-d]");
    const hEl = qs("[data-cd-h]");
    const mEl = qs("[data-cd-m]");
    const sEl = qs("[data-cd-s]");

    if (!endAt) {
      if (label) {
        label.textContent =
          label.getAttribute(`data-cd-fallback-${state.lang}`) || label.textContent;
      }
      return;
    }

    const left = Math.max(0, endAt - Date.now());
    const countdown = qs("[data-countdown]");
    const units = countdown ? countdown.querySelector(".countdown-units") : null;
    if (label) {
      label.textContent =
        left <= 0
          ? label.getAttribute(`data-cd-fallback-${state.lang}`) || label.textContent
          : label.getAttribute(`data-cd-label-${state.lang}`) || label.textContent;
    }
    if (units) units.hidden = left <= 0;

    const days = Math.floor(left / 86400000);
    const h = Math.floor((left % 86400000) / 3600000);
    const m = Math.floor((left % 3600000) / 60000);
    const s = Math.floor((left % 60000) / 1000);

    if (daysWrap) daysWrap.hidden = days <= 0;
    if (dEl) dEl.textContent = pad(days);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  };

  function onScroll() {
    const y = window.scrollY;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    if (progress) progress.style.width = `${max > 0 ? (y / max) * 100 : 0}%`;
    const atTop = y < 160;
    qs("[data-scroll-top]")?.classList.toggle("is-visible", !atTop);
    const offer = qs("[data-offer]");
    if (offer && stickyBuy) {
      const rect = offer.getBoundingClientRect();
      const pastHero = y > window.innerHeight * 0.55;
      const offerVisible = rect.top < window.innerHeight && rect.bottom > 120;
      stickyBuy.classList.toggle("is-visible", !atTop && pastHero && !offerVisible);
    }
  }

  let saved = "he";
  try {
    saved = localStorage.getItem("virelle-lang") || "he";
  } catch (_) {}
  applyLang(saved);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  syncFromShopify();
  setInterval(tick, 1000);
})();
